export default __webpack_public_path__ + "static/media/livestreming.fd2bf9db.svg";